"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.COMPANY_HOLIDAYS = void 0;
const core_contract_1 = require("./contracts/core.contract");
const thisYear = new Date().getFullYear();
exports.COMPANY_HOLIDAYS = [
    {
        name: "New Year's Day",
        type: core_contract_1.CompanyHolidayType.DATE,
        date: `${thisYear}-01-01`,
        repeats: true,
    },
    {
        name: "Martin Luther King Jr. Day",
        type: core_contract_1.CompanyHolidayType.NTH,
        repeats: true,
        dayOfWeek: 1,
        month: 1,
        nth: 3,
    },
    {
        name: "Presidents' Day",
        type: core_contract_1.CompanyHolidayType.NTH,
        repeats: true,
        dayOfWeek: 1,
        month: 2,
        nth: 3,
    },
    {
        name: "Memorial Day",
        type: core_contract_1.CompanyHolidayType.LAST,
        repeats: true,
        dayOfWeek: 1,
        month: 5,
    },
    {
        name: "Juneteenth",
        type: core_contract_1.CompanyHolidayType.DATE,
        date: `${thisYear}-06-19`,
        repeats: true,
    },
    {
        name: "Independence Day",
        type: core_contract_1.CompanyHolidayType.DATE,
        date: `${thisYear}-07-04`,
        repeats: true,
    },
    {
        name: "Labor Day",
        type: core_contract_1.CompanyHolidayType.NTH,
        repeats: true,
        dayOfWeek: 1,
        month: 9,
        nth: 1,
    },
    {
        name: "Columbus Day",
        type: core_contract_1.CompanyHolidayType.NTH,
        repeats: true,
        dayOfWeek: 1,
        month: 10,
        nth: 2,
    },
    {
        name: "Veterans Day",
        type: core_contract_1.CompanyHolidayType.DATE,
        date: `${thisYear}-11-11`,
        repeats: true,
    },
    {
        name: "Thanksgiving Day",
        type: core_contract_1.CompanyHolidayType.NTH,
        repeats: true,
        dayOfWeek: 4,
        month: 11,
        nth: 4,
    },
    // {
    //     workspaceId: workspace.id,
    //     name: "Day After Thanksgiving",
    //     type: CompanyHolidayType.DAY_AFTER,
    //     repeats: true,
    //     dayOfWeek: 4,
    //     month: 11,
    //     nth: 4,
    // },
    {
        name: "Christmas Eve",
        type: core_contract_1.CompanyHolidayType.DATE,
        date: `${thisYear}-12-24`,
        repeats: true,
    },
    {
        name: "Christmas Day",
        type: core_contract_1.CompanyHolidayType.DATE,
        date: `${thisYear}-12-25`,
        repeats: true,
    },
];
